import { Footer, Page, SiteHeader } from "../components/ui.tsx";
import { t } from "../i18n.ts";
import { linkHandler } from "../router.ts";
import { ContentCards } from "./Legal.tsx";

export function RulesContent() {
  return <ContentCards sections={t.rules.map(([title, text]) => ({ title, body: [text] }))} idPrefix="regel" />;
}

export function Rules() {
  return (
    <>
      <SiteHeader
        right={
          <a className="btn btn-outline btn-pill btn-small" href="/" onClick={linkHandler("/")}>
            ← {t.toHome}
          </a>
        }
      />
      <Page narrow>
        <h1 className="title-banner">{t.howItWorks}</h1>
        <RulesContent />
        <p className="muted" style={{ marginTop: 22, fontWeight: 800 }}>
          {t.defaultsInfo} · {t.noMoney}
        </p>
        <a className="btn btn-primary btn-large" href="/neu" onClick={linkHandler("/neu")}>
          {t.createRoom}
        </a>
      </Page>
      <Footer />
    </>
  );
}
